// Mock data for the application

import { Venue, Country } from '../types/tourOperator';
import { DocumentType } from '../types/tourOperator';

export interface ITSRecord {
  itsNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  arabicName: string;
  gender: string;
  dateOfBirth: string;
  email: string;
  mobile: string;
}


export const mockVenues: Venue[] = [
  { id: 'venue-1', name: 'Karbala Complex', location: 'Karbala, Iraq', country: 'Iraq', cutoffDays: 10, isActive: true },
  { id: 'venue-2', name: 'Najaf Center', location: 'Najaf, Iraq', country: 'Iraq', cutoffDays: 10, isActive: true },
  { id: 'venue-3', name: 'Mashhad Hall', location: 'Mashhad, Iran', country: 'Iran', cutoffDays: 15, isActive: true },
  { id: 'venue-4', name: 'Damascus Heritage', location: 'Damascus, Syria', country: 'Syria', cutoffDays: 12, isActive: true },
  { id: 'venue-5', name: 'Qom Center', location: 'Qom, Iran', country: 'Iran', cutoffDays: 15, isActive: true },
];

export const mockCountries: Country[] = [
  {
    id: 'iraq',
    name: 'Iraq',
    code: 'IQ',
    cities: [
      { id: 'baghdad', name: 'Baghdad', countryId: 'iraq' },
      { id: 'karbala', name: 'Karbala', countryId: 'iraq' },
      { id: 'najaf', name: 'Najaf', countryId: 'iraq' },
      { id: 'basra', name: 'Basra', countryId: 'iraq' },
    ]
  },
  {
    id: 'iran',
    name: 'Iran',
    code: 'IR',
    cities: [
      { id: 'tehran', name: 'Tehran', countryId: 'iran' },
      { id: 'mashhad', name: 'Mashhad', countryId: 'iran' },
      { id: 'qom', name: 'Qom', countryId: 'iran' },
      { id: 'shiraz', name: 'Shiraz', countryId: 'iran' },
    ]
  },
  {
    id: 'syria',
    name: 'Syria',
    code: 'SY',
    cities: [
      { id: 'damascus', name: 'Damascus', countryId: 'syria' },
      { id: 'aleppo', name: 'Aleppo', countryId: 'syria' },
    ]
  },
  {
    id: 'india',
    name: 'India',
    code: 'IN',
    cities: [
      { id: 'mumbai', name: 'Mumbai', countryId: 'india' },
      { id: 'delhi', name: 'Delhi', countryId: 'india' },
      { id: 'bangalore', name: 'Bangalore', countryId: 'india' },
    ]
  },
];

export const mockDocumentTypes: DocumentType[] = [
  {
    id: 'doc-passport',
    name: 'Passport Copy',
    description: 'Valid passport copy',
    isMandatory: true,
    allowedFormats: ['pdf', 'jpeg', 'jpg', 'gif'],
    maxSizeMB: 5,
    category: 'identity'
  },
  {
    id: 'doc-authorization',
    name: 'Authorization Letter',
    description: 'Business authorization letter',
    isMandatory: true,
    allowedFormats: ['pdf'],
    maxSizeMB: 3,
    category: 'authorization'
  },
  {
    id: 'doc-license',
    name: 'Business License',
    description: 'Valid business license',
    isMandatory: false,
    allowedFormats: ['pdf', 'jpeg', 'jpg'],
    maxSizeMB: 5,
    category: 'authorization'
  },
  {
    id: 'doc-misal',
    name: 'Misal Mubarak',
    description: 'Admin approval document',
    isMandatory: true,
    allowedFormats: ['pdf'],
    maxSizeMB: 3,
    category: 'approval'
  },
];

// Mock ITS data (simulating ITS server response)
export const mockITSData: Record<string, ITSRecord> = {
  '12345678': {
    itsNumber: '12345678',
    firstName: 'Ahmed',
    middleName: 'Ali',
    lastName: 'Hassan',
    arabicName: 'أحمد علي حسن',
    gender: 'male',
    dateOfBirth: '1985-05-15',
    email: 'ahmed.ali@email.com',
    mobile: '+964-770-1234567',
  },
  '87654321': {
    itsNumber: '87654321',
    firstName: 'Fatima',
    middleName: 'Mohammed',
    lastName: 'Ali',
    arabicName: 'فاطمة محمد علي',
    gender: 'female',
    dateOfBirth: '1990-03-22',
    email: 'fatima.ali@email.com',
    mobile: '+964-771-9876543',
  },
  '11223344': {
    itsNumber: '11223344',
    firstName: 'Hassan',
    middleName: 'Abbas',
    lastName: 'Raza',
    arabicName: 'حسن عباس رضا',
    gender: 'male',
    dateOfBirth: '1988-11-08',
    email: 'hassan.raza@email.com',
    mobile: '+964-772-1122334',
  },
  '44332211': {
    itsNumber: '44332211',
    firstName: 'Zainab',
    middleName: 'Hussein',
    lastName: 'Kadhim',
    arabicName: 'زينب حسين كاظم',
    gender: 'female',
    dateOfBirth: '1992-07-19',
    email: 'zainab.hussein@email.com',
    mobile: '+964-773-4433221',
  },
  '55667788': {
    itsNumber: '55667788',
    firstName: 'Mohammed',
    middleName: 'Jawad',
    lastName: 'Al-Najafi',
    arabicName: 'محمد جواد النجفي',
    gender: 'male',
    dateOfBirth: '1987-09-12',
    email: 'mohammed.najafi@email.com',
    mobile: '+964-774-5566778',
  },
  '99887766': {
    itsNumber: '99887766',
    firstName: 'Ali',
    middleName: 'Reza',
    lastName: 'Karimi',
    arabicName: 'علي رضا كريمي',
    gender: 'male',
    dateOfBirth: '1991-04-25',
    email: 'ali.karimi@email.com',
    mobile: '+964-775-9988776',
  },
  '22334455': {
    itsNumber: '22334455',
    firstName: 'Maryam',
    middleName: 'Zahra',
    lastName: 'Hussaini',
    arabicName: 'مريم زهراء حسيني',
    gender: 'female',
    dateOfBirth: '1989-12-03',
    email: 'maryam.hussaini@email.com',
    mobile: '+964-776-2233445',
  },
};

// Helper function to fetch ITS data (simulates API call)
export const fetchITSData = async (itsNumber: string) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 800));
  
  const data = mockITSData[itsNumber];
  if (!data) {
    throw new Error('ITS Number not found');
  }
  
  return data;
};
